import React, { useState, useEffect } from 'react';
import { Provider, useDispatch } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import store from './redux/store';
import AppRoutes from './routes';
import Navbar from './components/Navbar';
import { loadOnboardingState } from './redux/onboardingReducer';
const lightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#1976d2',
    },
  },
});

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#90caf9',
    },
  },
});

const blueTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#2196f3',
    },
    background: {
      default: '#e3f2fd',
    },
  },
});

const themes = {
  light: lightTheme,
  dark: darkTheme,
  blue: blueTheme,
};

function AppContent() {
  const [currentTheme, setCurrentTheme] = useState('light');
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(loadOnboardingState());
  }, [dispatch]);

  const handleThemeChange = (theme) => {
    setCurrentTheme(theme);
  };

  return (
    <ThemeProvider theme={themes[currentTheme]}>
      <CssBaseline />
      <DndProvider backend={HTML5Backend}>
        <Navbar onThemeChange={handleThemeChange} />
        <AppRoutes />
      </DndProvider>
    </ThemeProvider>
  );
}

function App() {
  return (
    <Provider store={store}>
      <Router>
        <AppContent />
      </Router>
    </Provider>
  );
}

export default App;
